import t from"dayjs";var r=r=>{if(!r)return null;const o=t(r).startOf("month");return o.isValid()?o.toISOString():null};export{r as toIsoMonth};
//# sourceMappingURL=toIsoMonth.js.map